const nameData = "products"; // Define la entidad dinámica
const nameDataSingular = "articulo"; // Para el caso singular

export const fetchEntityData = async (getEntityPanelData, searchTerm,searchIDRam, searchIDRub, searchIDSubr, searchIDMar, searchDes,searchStock, numPagina, filas,selectOrderBy,selectOrder, findNoCombo) => {
  try {
    const data = await getEntityPanelData(searchTerm, searchIDRam, searchIDRub, searchIDSubr, searchIDMar, searchDes, searchStock,numPagina, filas,selectOrderBy, selectOrder);
    if (data) {
      const totalPage = data.pagination.totalPage || 1;
      const totalDataItems = data.pagination.totalItems || 0;
      return {
        dataEntity: data[nameData] || [], // Usa nameData dinámicamente
        totalItems: data.pagination.totalItems || 0,
        totalPage,
        totalDataItems
      };
    }
  } catch (error) {
    console.error(`Error al cargar ${nameData}:`, error);
    throw error;
  }
};

export const deleteItem = async (deleteEntityData, selectedItem) => {
  try {
    await deleteEntityData(selectedItem);
  } catch (error) {
    console.error(`Error al eliminar el ${nameDataSingular}:`, error);
    throw error;
  }
};
